import * as types from "./mutations-type";
export default{
   
    [types.SET_TABELAPRECO](state,payload){
        state.tabelapreco = payload
    },
    
}